<template>

    <modal v-if="showConfirm" @close="$emit('cancel')">
        <h2 slot="header">Are you sure?</h2>
        <p slot="body">{{ confirmMessage }}</p>
        <div slot="footer">
            <button
                class="modal-default-button btn btn-default margin-left-10"
                type="button"
                @click="$emit('cancel')"
            >
                Cancel
            </button>
            <button
                class="modal-default-button btn btn-danger"
                type="button"
                @click="$emit('ok')"
            >
                OK
            </button>
        </div>
    </modal>

</template>

<script>
  import Modal from './Modal.vue'

  export default {

    props: ['showConfirm', 'confirmMessage'],

    components: {
      Modal
    },

     events: {
         ok() {
           this.showConfirm = false;
         },
        cancel() {
            this.showConfirm = false;
         }
    },

  }
</script>
